import React from "react";
//import PropTypes from "prop-types";
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { getTranslate } from "react-localize-redux";
import { getUserDetails, putUserDetails, postUserAvatar } from '../../actions/user'

// material-ui components
import withStyles from "material-ui/styles/withStyles";
import InputLabel from "material-ui/Input/InputLabel";
import FormLabel from "material-ui/Form/FormLabel";
import FormControlLabel from "material-ui/Form/FormControlLabel";
import Checkbox from "material-ui/Checkbox";
import MenuItem from "material-ui/Menu/MenuItem";
import FormControl from "material-ui/Form/FormControl";
import Select from "material-ui/Select";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import ItemGrid from "components/Grid/ItemGrid.jsx";
import ProfileCard from "components/Cards/ProfileCard.jsx";
import RegularCard from "components/Cards/RegularCard.jsx";
import IconCard from "components/Cards/IconCard.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Clearfix from "components/Clearfix/Clearfix.jsx";
import PictureUpload from "components/CustomUpload/PictureUpload.jsx";


// @material-ui/icons
import PermIdentity from "@material-ui/icons/PermIdentity";
import Check from "@material-ui/icons/Check";


import avatar from "assets/img/faces/marc.jpg";

import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";


class UserProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      email: "",
      firstName: "",
      lastName: "",
      city: "",
      country:"",
      roles:{admin:false,dev:false,customer:false,receiver:false},
    };
    this.handleInput = this.handleInput.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleRoleToggle = this.handleRoleToggle.bind(this);

  }

  handleInput(e){
    this.setState({ [e.target.name]: e.target.value });
  }

  handleRoleToggle(e){
    let roles = this.state.roles;
    roles[e.target.name] = e.target.checked;
    this.setState({ roles });    
  }

  handleSubmit(event){
    event.preventDefault();
    this.props.dispatchPutUserDetails(this.props.auth.user, this.state)

  }

  componentDidMount() {
    this.props.dispatchGetUserDetails(this.props.auth.user)
    .then( user => {
      if(user.type==="USER_GET_DETAILS_FAILURE"){
        console.log(user);
      }else{
        this.setState(user);        
      }
    });   
  }

  render() {
      const {  translate, classes } = this.props;

      const roles = [
        {
          id:"admin",
          label:"Admin"
        },
        {
          id:"dev",
          label:"Dev"
        },
        {
          id:"customer",
          label:"Customer"
        },
        {
          id:"receiver",
          label:"Receiver"
        },
      ];

      return (
        <div>
          <GridContainer>
            <ItemGrid xs={12} sm={12} md={8}>
              <IconCard
                icon={PermIdentity}
                iconColor="rose"
                title="Edit Profile - "
                category="Complete your profile"
                content={
                  <div>
                    <GridContainer>
                      <ItemGrid xs={12} sm={12} md={5}>
                        <CustomInput
                          labelText="Company (disabled)"
                          id="company-disabled"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            disabled: true
                          }}
                        />
                      </ItemGrid>
                      <ItemGrid xs={12} sm={12} md={3}>
                        <CustomInput
                          labelText={translate("layout.user.username")}
                          id="username"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            onChange: this.handleInput,
                            name: "username",  
                            value: this.state.username,  
                          }}                          
                        />
                      </ItemGrid>
                      <ItemGrid xs={12} sm={12} md={4}>
                        <CustomInput
                          labelText={translate("layout.user.email")}
                          id="email-address"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            onChange: this.handleInput,
                            name: "email",  
                            value: this.state.email,  
                          }}                            
                        />
                      </ItemGrid>
                    </GridContainer>
                    <GridContainer>
                      <ItemGrid xs={12} sm={12} md={6}>
                        <CustomInput
                          labelText={translate("layout.user.firstName")}
                          id="first-name"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            onChange: this.handleInput,
                            name: "firstName",  
                            value: this.state.firstName,  
                          }}                              
                        />
                      </ItemGrid>
                      <ItemGrid xs={12} sm={12} md={6}>
                        <CustomInput
                          labelText={translate("layout.user.lastName")}
                          id="last-name"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            onChange: this.handleInput,
                            name: "lastName",  
                            value: this.state.lastName,  
                          }}                              
                        />
                      </ItemGrid>
                    </GridContainer>
                    <GridContainer>
                      <ItemGrid xs={12} sm={12} md={4}>
                         <FormControl
                              fullWidth
                              className={classes.selectFormControl}
                            >
                              <InputLabel
                                htmlFor="city"
                                className={classes.selectLabel}
                              >
                                Choose City
                              </InputLabel>
                              <Select
                                MenuProps={{
                                  className: classes.selectMenu
                                }}
                                classes={{
                                  select: classes.select
                                }}
                                value={this.state.city}
                                onChange={this.handleInput}
                                inputProps={{
                                  name: "city",
                                  id: "city"
                                }}
                              >
                                <MenuItem
                                  disabled
                                  classes={{
                                    root: classes.selectMenuItem
                                  }}
                                >
                                  Choose City
                                </MenuItem>
                              {[{name:"Ottawa"},{name:"Paris"},{name:"Bucharest"}].map((prop, key) => {
                                return (
                                <MenuItem
                                  key={prop.name}
                                  classes={{
                                    root: classes.selectMenuItem,
                                    selected: classes.selectMenuItemSelected
                                  }}
                                  value={prop.name}
                                >
                                  {prop.name}
                                </MenuItem>
                                )})}
                              </Select>
                            </FormControl>
                      </ItemGrid>
                      <ItemGrid xs={12} sm={12} md={4}>
                        <FormControl
                              fullWidth
                              className={classes.selectFormControl}
                            >
                              <InputLabel
                                htmlFor="country"
                                className={classes.selectLabel}
                              >
                                Choose Country
                              </InputLabel>
                              <Select
                                MenuProps={{
                                  className: classes.selectMenu
                                }}
                                classes={{
                                  select: classes.select
                                }}
                                value={this.state.country}
                                onChange={this.handleInput}
                                inputProps={{
                                  name: "country",
                                  id: "country"
                                }}
                              >
                                <MenuItem
                                  disabled
                                  classes={{
                                    root: classes.selectMenuItem
                                  }}
                                >
                                  Choose Country
                                </MenuItem>
                              {[{name:"Canada","code":"CA"},{name:"United States","code":"US"},{name:"Romania","code":"RO"},{name:"France","code":"FR"}].map((prop, key) => {
                                return (
                                <MenuItem
                                  key={prop.code}
                                  classes={{
                                    root: classes.selectMenuItem,
                                    selected: classes.selectMenuItemSelected
                                  }}
                                  value={prop.code}
                                >
                                  {prop.name}
                                </MenuItem>
                                )})}
                              </Select>
                            </FormControl>
                      </ItemGrid>
                      <ItemGrid xs={12} sm={12} md={4}>
                        <CustomInput
                          labelText="Postal Code"
                          id="postal-code"
                          formControlProps={{
                            fullWidth: true
                          }}
                        />
                      </ItemGrid>
                    </GridContainer>
                    <GridContainer>
                      <ItemGrid xs={12} sm={2}>
                    <FormLabel className={classes.labelHorizontal + " " + classes.labelHorizontalRadioCheckbox}>
                      Roles
                    </FormLabel>
                  </ItemGrid>
                  <ItemGrid xs={12} sm={10}>
                    <div className={classes.inlineChecks}>
                      {roles.map((prop, key) => {
                      return (
                      <FormControlLabel
                        key={prop.id}
                        control={
                          <Checkbox
                            tabIndex={-1}
                            onClick={(e) => this.handleRoleToggle(e)}
                            checkedIcon={
                              <Check className={classes.checkedIcon} />
                            }
                            icon={<Check className={classes.uncheckedIcon} />}
                            classes={{
                              checked: classes.checked
                            }}
                            name={prop.id}
                            checked={this.state.roles[prop.id]}
                          />
                        }
                        classes={{
                          label: classes.label
                        }}
                        label={prop.label}
                      />
                      ); }) }
                    </div>
                  </ItemGrid>
                    </GridContainer>
                    <Button color="rose" onClick={this.handleSubmit} right  >
                      Update Profile
                    </Button>
                    <Clearfix />
                  </div>
                }
              />
            </ItemGrid>
            <ItemGrid xs={12} sm={12} md={4}>
              <RegularCard
                content={
                  <PictureUpload
                    imagePreviewUrl={this.props.userDetails.cognitoId?"https://media.dev.mysafedelivery.com/"+this.props.userDetails.cognitoId+"/avatar-500x500.png":null}
                    onImageChange={(file, base64)=>{
                      this.props.dispatchPostUserAvatar(this.props.auth.user, file, base64);
                    }}
                   />
                }
              />
            </ItemGrid>
          </GridContainer>
        </div>
      );
    }
}


const mapDispatchToProps = {
  dispatchGetUserDetails: user => getUserDetails(user),
  dispatchPutUserDetails: (user, data) => putUserDetails(user, data),
  dispatchPostUserAvatar: (user, file, base64) => postUserAvatar(user, file, base64),
}

const mapStateToProps = (state, props) => {
  return {
    translate: getTranslate(state.localize),
    auth: state.auth,
    userDetails: state.user.userDetails,
    userRoles: state.user.roles,
  }
}


export default compose(
  withStyles(regularFormsStyle),
  connect(mapStateToProps, mapDispatchToProps)
)(UserProfile);




// WEBPACK FOOTER //
// ./src/views/User/UserProfile.jsx